import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddPublicatieCasatoriePayload, IEditPublicatieCasatoriePayload } from './publicatii-casatorii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PublicatiiCasatoriiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listDTPublicatiiURL =
        this.basePath + environment.interop.deps.publicatii.listDT;
    private addPublicatieURL =
        this.basePath + environment.interop.deps.publicatii.store;
    private updatePublicatieURL =
        this.basePath + environment.interop.deps.publicatii.update;
    private deletePublicatieURL =
        this.basePath + environment.interop.deps.publicatii.delete;

    constructor(private http: HttpClient) { }

    listDTPublicatii() {
        return this.http.post(this.listDTPublicatiiURL, {});
    }

    addPublicatie(data: IAddPublicatieCasatoriePayload) {
        return this.http.post(this.addPublicatieURL, data);
    }

    updatePublicatie(id: number, data: IEditPublicatieCasatoriePayload) {
        return this.http.post(this.updatePublicatieURL + id, data);
    }

    deletePublicatie(id: number) {
        return this.http.delete(this.deletePublicatieURL + id);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
